@if (visible()) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="tra-backdrop" (click)="cancel()">
    <div
      class="tra-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tra-title"
      aria-describedby="tra-message"
      data-testid="testrun-abort-dialog"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="$event.stopPropagation()"
      (keydown.escape)="cancel()"
    >
      <div class="tra__header">
        <div class="tra__icon" aria-hidden="true">
          <mat-icon>stop_circle</mat-icon>
        </div>
        <div class="tra__heading">
          <h2 class="tra__title" id="tra-title">{{ 'testRuns.abortDialog.title' | translate }}</h2>
          <p class="tra__message" id="tra-message" data-testid="testrun-abort-message">
            {{ 'testRuns.abortDialog.message' | translate }}
          </p>
        </div>
        <button
          type="button"
          class="tra__close"
          data-testid="testrun-abort-close"
          [attr.aria-label]="'testRuns.abortDialog.close' | translate"
          [disabled]="submitting()"
          (click)="cancel()"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>

      @if (unsavedInput()) {
        <p class="tra__unsaved" data-testid="testrun-abort-unsaved">
          <mat-icon aria-hidden="true">warning</mat-icon>
          {{ 'testRuns.abortDialog.unsaved' | translate }}
        </p>
      }

      <div class="tra__body">
        <label class="tra__label" for="tra-reason">
          {{ 'testRuns.abortDialog.reasonLabel' | translate }}
          <span aria-hidden="true">*</span>
        </label>
        <textarea
          #reasonField
          id="tra-reason"
          class="tra__reason"
          rows="3"
          required
          aria-required="true"
          data-testid="testlauf-abort-reason"
          [class.tra__reason--invalid]="tooLong()"
          [attr.aria-invalid]="tooLong() ? 'true' : null"
          [attr.aria-describedby]="tooLong() ? 'tra-counter tra-too-long' : 'tra-counter'"
          [attr.maxlength]="fieldLengths.ABORT_REASON_MAX"
          [attr.placeholder]="'testRuns.abortDialog.reasonPlaceholder' | translate"
          [disabled]="submitting()"
          [value]="reason()"
          (input)="reason.set(reasonField.value)"
        ></textarea>
        <div class="tra__below">
          @if (tooLong()) {
            <p class="tra__too-long" id="tra-too-long" data-testid="testrun-abort-too-long">
              {{ 'testRuns.abortDialog.tooLong' | translate: { max: fieldLengths.ABORT_REASON_MAX } }}
            </p>
          }
          <p class="tra__counter" id="tra-counter" aria-live="polite" data-testid="testrun-abort-counter">
            {{ reason().length }} / {{ fieldLengths.ABORT_REASON_MAX }}
          </p>
        </div>
      </div>

      @if (errorKey(); as key) {
        <p #errorMessage class="tra__error" role="alert" tabindex="-1" data-testid="testrun-abort-error">
          {{ key | translate }}
        </p>
      }

      <div class="tra__actions">
        <button
          type="button"
          class="tra__btn tra__btn--ghost"
          data-testid="testrun-abort-cancel"
          [disabled]="submitting()"
          (click)="cancel()"
        >
          {{ 'testRuns.abortDialog.cancel' | translate }}
        </button>
        <button
          type="button"
          class="tra__btn tra__btn--danger"
          data-testid="testrun-abort-confirm"
          [disabled]="!canSubmit()"
          (click)="submit()"
        >
          @if (submitting()) {
            <mat-spinner diameter="16" [attr.aria-label]="'testRuns.abortDialog.submitting' | translate" />
          } @else {
            <mat-icon aria-hidden="true">stop_circle</mat-icon>
          }
          {{ 'testRuns.abortDialog.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
}
